import React from 'react';
const InputHtmlRenderer = (props) => {
    return (React.createElement("div", { id: "form-status", className: "form-status", style: { display: "none" } }));
};
export default InputHtmlRenderer;
//# sourceMappingURL=FormStateHtmlRenderer.js.map